import React, { FC } from "react"
import CardTable from "../../../ui/table/CardTable"

type ReleaseUpcCodesProps = {
  userAdminPermissions?: string
}

const ReleaseUpcCodes: FC<ReleaseUpcCodesProps> = (props) => {
  return (
    <div className="flex justify-center">
      <CardTable
        userAdminPermissions={props.userAdminPermissions}
        title={`Release Upc Codes`}
        urlBase="upc_codes"
        dataName="UPC"
        dataKey="upc"
        itemName="UPC Code"
        iconPath="/record-label.svg"
      />
    </div>
  )
}

export default ReleaseUpcCodes
